<template>
    <v-list-item link :to="route" color="purple" prepend-icon="mdi-set-merge">
        <v-list-item-title class="text-subtitle-2">
            {{ group.name || "(unnamed group)" }}
            <span class="mx-1 font-weight-light text-grey text-caption pit-mono">{{ group.uuid.slice(0, 8) }}</span>
        </v-list-item-title>
        <v-list-item-subtitle class="text-no-wrap">
            <v-chip size="x-small" variant="outlined" color="info">{{ batch_chip }}</v-chip>
            <v-chip v-for="name in member_design_names" :key="name"
                class="ml-1" size="x-small" variant="tonal" color="purple">
                {{ name }}
            </v-chip>
            <br />
            <ChipMultipanelGroupStatus :group="group" inline />
        </v-list-item-subtitle>
    </v-list-item>
</template>

<script>
import { useConstructiblesStore } from "@/stores/constructibles";
import ChipMultipanelGroupStatus from "@/components/renderers/ChipMultipanelGroupStatus.vue";
export default {
    components: { ChipMultipanelGroupStatus },
    setup() {
        return { constructibles_store: useConstructiblesStore() }
    },
    props: ["group"],
    computed: {
        batch() {
            return this.constructibles_store.batchesByUuid.get(this.group?.batch)
        },
        batch_chip() {
            const batch_name = this.batch?.name || ""
            const phase = this.batch?.phase || ""
            return `${phase} | ${batch_name}`
        },
        member_count() {
            return (this.group?.memberships || []).length
        },
        member_design_names() {
            const assemblies = this.constructibles_store.assemblies || []
            const ass_by_uuid = new Map(assemblies.map(a => [a.uuid, a]))
            const designsByUuid = this.constructibles_store.designsByUuid
            const seen = new Set()
            const ordered = [...(this.group?.memberships || [])]
                .sort((a, b) => (a.position || 0) - (b.position || 0))
            const out = []
            for (const m of ordered) {
                const a = ass_by_uuid.get(m.assembly)
                const d = a ? designsByUuid.get(a.design) : null
                const name = d?.name
                if (name && !seen.has(name)) {
                    seen.add(name)
                    out.push(name)
                }
            }
            return out
        },
        route() {
            return `/viewer/multipanel_group/${this.group.uuid}`
        },
    },
}
</script>
